import React, { useRef, useMemo } from 'react';

import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  DropdownButtonContainer,
  DropdownButton,
  ExpandIcon,
  ButtonLabel,
  DropdownListContainer,
  DropdownItemButton,
  DropdownItemLabel,
} from './styles';

export default function Dropdown({
  value,
  icon,
  options = [],
  onChange,
  leftDrop,
  width,
  id,
  disabled,
  isSmallDropdown,
  isFreecode,
}) {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);

  const actuallyDisabled = useMemo(() => !options?.length || disabled, [options, disabled]);

  const toggleDropdown = () => setIsActive(!isActive);

  const optionClick = (option) => {
    onChange(option);
    setIsActive(false);
  };

  return (
    <DropdownButtonContainer ref={dropdownRef} id={id}>
      <DropdownButton
        onClick={toggleDropdown}
        width={width}
        disabled={actuallyDisabled}
        isSmallDropdown={isSmallDropdown}
        isFreecode={isFreecode}
      >
        <ButtonLabel disabled={actuallyDisabled}>
          {icon}
          <span>{value}</span>
        </ButtonLabel>
        {!actuallyDisabled && <ExpandIcon isOpen={isActive} />}
      </DropdownButton>
      {!actuallyDisabled && isActive && (
        <DropdownListContainer leftDrop={leftDrop}>
          {options.map((option, index) => (
            <DropdownItemButton key={index} isSelected={option.isSelected} onClick={() => optionClick(option)}>
              <DropdownItemLabel>
                {option.icon}
                {option.label}
              </DropdownItemLabel>
            </DropdownItemButton>
          ))}
        </DropdownListContainer>
      )}
    </DropdownButtonContainer>
  );
}
